export const wmComponents = () => {
  const components = {
    showPopupBlockerAlert: () => {
      const blockedPopupMessage = document.querySelector(
        "[data-wm-popup-blocker-alert]"
      );

      blockedPopupMessage.classList.add("active");

      setTimeout(() => {
        blockedPopupMessage.classList.remove("active");
      }, 6000);
    },
  };

  window.wemove.components = components;
};
